import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';
import { ActivityTimer } from '~/components/account/async.js';
import { getZindexByType } from '~/utils/style-utils';
import { showNotification } from '../../notifications/ducks/notifications.js';
import { RegulationSideWrapper, ActivityTimerWrapper } from './wrappers.js';
import { LinkWithPressEffect } from './links.js';
import { isNativeRegHeaderEnabled } from '~/components/app-bridge/app-properties.js';
import LogoSpelPaus from '~/components/header/regulations-header/sga-logos/logo-spelpaus';
import LogoSpelGrans from '~/components/header/regulations-header/sga-logos/logo-spelgrans';
import LogoSjalvTest from '~/components/header/regulations-header/sga-logos/logo-sjalvtest';
import Anchor from '~/components/misc/anchor';

export const Wrapper = styled.div`
	background-color: var(--sga-head-bg-color, #d3d3d5);
	border-bottom: var(--sga-head-border-bottom-color, none);
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	max-width: 100vw;
	height: var(--regulationHeight);
	z-index: ${getZindexByType('regulations-header')};
	a,
	button {
		background-color: var(--sga-head-icon-bg, rgba(var(--base-01), 1));
		border: var(--sga-head-border, none);
		border-radius: 30px;
		margin-left: 10px;
	}
	span:first-child a {
		margin-left: 0;
	}
`;

const AnchorIconPause = styled(LinkWithPressEffect)`
	padding: 3px 6px 3px 2px;
`;

const AnchorIconGrans = styled(LinkWithPressEffect)`
	padding: 3px 6px 3px 3px;
`;

const AnchorIconTest = styled(Anchor)`
	padding: 3px 6px 3px 2px;
`;

const RegulationsHeaderSGA = () => {
	const authenticated = useSelector(authenticationSelector);
	const dispatch = useDispatch();
	const onClickLimits = useCallback(() => {
		if (!authenticated) {
			setTimeout(
				dispatch(
					showNotification({
						messageKey: 'LOGIN_MESSAGE_LIMITS',
						color: 'red',
						openInSidebar: true,
						autoHide: true
					})
				),
				2000
			);
		}
	}, [authenticated, dispatch]);
	const show = !isNativeRegHeaderEnabled();
	return (
		show && (
			<Wrapper id="regulations-header" data-at="regulation-header-wrapper">
				<>
					{!authenticated && (
						<AnchorIconPause
							target="_blank"
							href="https://www.spelpaus.se/?scos=true"
							dataAt="regulation-header-spel-paus"
						>
							<LogoSpelPaus width={70} height={20} />
						</AnchorIconPause>
					)}
					{authenticated && (
						<AnchorIconPause
							to="?sidebar=account%2Csettings%2Cclose-catalog"
							dataAt="regulation-header-settings"
						>
							<LogoSpelPaus width={70} height={20} />
						</AnchorIconPause>
					)}

					<AnchorIconGrans
						to="/account/my-limits"
						dataAt="regulation-header-responsible-gaming"
						onClick={onClickLimits}
					>
						<LogoSpelGrans width={84} height={20} />
					</AnchorIconGrans>

					{!authenticated && (
						<AnchorIconTest
							target="_blank"
							href="https://stodlinjen.se/#!/spelberoende-test-pgsi"
							data-at="regulation-header-self-test"
						>
							<LogoSjalvTest width={67} height={20} />
						</AnchorIconTest>
					)}
					{authenticated && (
						<AnchorIconTest
							target="_blank"
							href="https://stodlinjen.se/#!/spelberoende-test-pgsi"
							data-at="regulation-header-self-test"
						>
							<LogoSjalvTest width={67} height={20} />
						</AnchorIconTest>
					)}
				</>

				{authenticated && (
					<RegulationSideWrapper>
						<ActivityTimerWrapper>
							<ActivityTimer className="session-timer--regulation-header" />
						</ActivityTimerWrapper>
					</RegulationSideWrapper>
				)}
			</Wrapper>
		)
	);
};

export default RegulationsHeaderSGA;
